import { withTranslation } from 'react-i18next';
import Component from '../../../components/Component';
import Timeline from '../../../components/Timeline';
import { getLabel } from '../../../helpers/date';
import { colors } from '../../../lib/colors';
import { chartKeys } from './keys';

class Chart extends Component {
    constructor() {
        super();
    }
    render() {
        const { t } = this.props;

        const chartData = (datasetIndex) => ({
            labels: this.props.data.map((item) => [
                getLabel(item?.start_date?.value),
                getLabel(item?.end_date?.value),
            ]),
            datasets: chartKeys(t).map((item, i) => ({
                label: item?.label,
                type: item.type ?? 'line',
                data: this.props.data.map((data) =>
                    item.render ? item.render(data[item.key]) : data[item.key],
                ),
                backgroundColor: colors[i],
                borderColor:
                    datasetIndex === null || datasetIndex === i
                        ? colors[i]
                        : 'rgba(128, 128, 128, 0.2)',
                yAxisID: item.yAxisID ?? 'y',
                hidden: item.hidden ?? false,
                borderRadius: 4,
                tension: 0.4,
            })),
        });

        return (
            <Timeline
                chartSize="lg"
                metricType="primary"
                data={this.props.data}
                keys={chartKeys(t)}
                forceRun={this.forceRun}
                chartData={chartData}
                hasRightAxis
                rightAxisLabel={t('search.directories_details.directory_detail.rightAxisLabel')}
                leftAxisLabel={t('search.directories_details.directory_detail.leftAxisLabel')}
                xAxisKey="start_date"
                showGoogleFeeds
            />
        );
    }
}

export default withTranslation()(Chart);
